import { Component, ElementRef, Input, OnInit, SimpleChanges } from '@angular/core';
import { Profile } from '../../../interfaces/user';

/**
 * 응답이 어떤식으로 표현 될 것인지 알려주는 컴포넌트
 * ex) 예지님의 응답 - 이중 동그라미 / 내 응답 - 체크 표시
 */
@Component({
  selector: 'app-answer-type-example',
  templateUrl: './answer-type-example.component.html',
  styleUrls: ['../../../../theme/radio-button.scss', '../mbti-question/question.scss', './answer-type-example.component.scss']
})
export class AnswerTypeExampleComponent implements OnInit {

  @Input() type: 'host' | 'guest' = 'guest';
  @Input() mainCheckedLabel: string | undefined;// = '예지님의 응답'; // 메인 선택 라벨
  @Input() compareCheckedLabel: string | undefined;// = '내 응답'; // 비교 선택 라벨
  @Input() compareCheckType?: 'check' | 'ticker' | 'image' = 'check';
  @Input() profile?: Profile;
  @Input() respondentFirstName?: string;
  @Input() imageUrl?: string;

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit(): void {
  }
}
